import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { IEntityFilter } from './IEntityFilter';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ISplitDay } from './ISplitDay';

@Injectable({
    providedIn: 'root'
})
export class SplitDayService {
  uri = `${environment.apiLocation}/SplitDay`;
  constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}
    loadSplitdays(): Observable<Array<ISplitDay>> {
      return this.http
      .get<Array<ISplitDay>>(this.uri)
      .pipe(
          tap(res =>
              this.log.verbose({
                  type: 'SplitDayService:reponse',
                  res
              })
          )
      );
    }
}
